import { createContext, useContext, useEffect } from 'react';
import { usePersistState } from '@/shared/hooks/state';

const GlobalContext = createContext(null);

export function GlobalProvider({ children }) {
  const [theme, setTheme] = usePersistState('theme', 'light');
  const [lang, setLang] = usePersistState('language', 'ru');

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [theme]);

  return (
    <GlobalContext.Provider value={{ theme, setTheme, lang, setLang }}>
      {children}
    </GlobalContext.Provider>
  );
}

export function useGlobal() {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error('useGlobal must be used within a GlobalProvider.');
  }
  return context;
}
